import Skeleton from '@mui/material/Skeleton';
import React from 'react';

const TasksSkelton = ({ length = 6 }) => {
  return (
    <div className="tasks-body">
      <Skeleton variant="rounded" width={100} height={16} className='mb-2' />
      {[...Array(length)].map((item, index) => (
        <div className="task p-5 w-100 d-flex align-items-center justify-content-between mb-5"
          style={{ background: "#F3F6F9" }}
        >
          <div className="d-flex">
            <Skeleton variant="circular" width={40} height={40} className="mr-4" />
            <div>
              <Skeleton variant="rounded" width={100} height={16} className="mb-2" />
              <Skeleton variant="rounded" width={100} height={16} />
            </div>
          </div>
          <div className="d-flex h-100 justify-content-start">
            <Skeleton variant="rounded" width={60} height={16} className="mr-2" />
            <Skeleton variant="rounded" width={20} height={16} />
          </div>
        </div>
      ))}
    </div>
  )
}

export default TasksSkelton